"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributeValue = exports.fulfillmentGroupMapper = exports.FulfillmentGroup = exports.deliveryInstructionsKeys = exports.DeliveryInstructionsKeys = exports.localeToDateFnsLocaleMapper = exports.StockStatus = exports.channelMapper = exports.isStar1Locale = exports.languageCodeMapper = exports.countryCodeMapper = exports.convertRawLocaleToCtLocale = exports.STAR2LocalesScand = exports.STAR2LocalesWithMultipleLanguages = exports.LocaleStar2 = exports.STAR1Locales = exports.mapCountryCodeToStar2StoreKey = exports.getAgeGroup = exports.storeToChannelsMapper = exports.sizeMapper = exports.fitLabelMapper = exports.fitMapper = exports.getSizeAttributeName = exports.getFitLabelAttributeName = exports.getFitAttributeName = exports.isStar2StoreLocale = exports.isStar2StoreKey = exports.localeToRegisteredFromMapper = exports.storeKeyMapper = exports.getCtLocleToISO = exports.isStar2Country = exports.getStar2Countries = exports.ctLocaleToStoreLocales = exports.mapCountryToCurrency = exports.countryToCurrencyMapper = exports.currencyCountryMapper = exports.currencyMapper = exports.defaultLocale = exports.localesConfluent = exports.getIndexedStoresList = exports.storeToLocales = exports.eventChannelToCTChannel = exports.eventChannelToStore = exports.localeMappingStar2 = exports.channelToLocale = exports.mapChannelFromEvent = exports.csaChannelSuffix = exports.ChannelFromEvent = exports.Locales = exports.AgeGroup = void 0;
exports.isSupportedCtLocale = exports.normalizeLocaleCase = exports.getLocalizedBooleanAttributeValue = exports.getLocalizedBooleanValue = exports.parseToCents = exports.generateInvalidateDelivery = exports.isOutletLocale = exports.isOutlet = exports.upperCasePromoCode = exports.isStoreWithStockReservation = exports.INVENTORY_RESERVATION_STORES = exports.getDigitalCartUpdateActions = exports.hasValidDummyAddress = exports.hasDummyAddress = exports.getDummyAddress = exports.DUMMY_ADDRESS_PREFIX = exports.cartHasGiftCard = exports.cartHasPhysicalGiftCard = exports.isGiftCardCart = exports.isDigitalCart = exports.isGiftCardProduct = exports.isPhysicalGiftCardProduct = exports.isDigitalProduct = exports.getPrimaryCategory = void 0;
const types_1 = require("@ct/types");
const assert_1 = require("assert");
const locale_1 = require("date-fns/locale");
const i18n_1 = require("../i18n");
__exportStar(require("./inventories"), exports);
__exportStar(require("./shippingMethods"), exports);
var AgeGroup;
(function (AgeGroup) {
    AgeGroup["ADULT"] = "adult";
    AgeGroup["JUNIOR"] = "junior";
    AgeGroup["INFANT"] = "infant";
})(AgeGroup || (exports.AgeGroup = AgeGroup = {}));
var Locales;
(function (Locales) {
    Locales["EN_GB"] = "en-GB";
    Locales["EN_GB_OUTLET"] = "en-GB-OUTLET";
    Locales["EN_US"] = "en-US";
    Locales["EN_IE"] = "en-IE";
    Locales["EN_CA"] = "en-CA";
    Locales["FR_CA"] = "fr-CA";
    Locales["FR_FR"] = "fr-FR";
    Locales["DE_DE"] = "de-DE";
    Locales["IT_IT"] = "it-IT";
    Locales["ES_ES"] = "es-ES";
    Locales["NL_NL"] = "nl-NL";
    Locales["DE_AT"] = "de-AT";
    Locales["NL_BE"] = "nl-BE";
    Locales["FR_BE"] = "fr-BE";
    Locales["DE_CH"] = "de-CH";
    Locales["FR_CH"] = "fr-CH";
    Locales["IT_CH"] = "it-CH";
    Locales["EN_DK"] = "en-DK";
    Locales["EN_PL"] = "en-PL";
    Locales["EN_SM"] = "en-SM";
    Locales["IT_SM"] = "it-SM";
    Locales["EN_LU"] = "en-LU";
    Locales["FR_LU"] = "fr-LU";
    Locales["EN_EUROPE"] = "en-EUROPE";
    Locales["EN_SCAND"] = "en-SCAND";
})(Locales || (exports.Locales = Locales = {}));
var ChannelFromEvent;
(function (ChannelFromEvent) {
    ChannelFromEvent["UK"] = "eCommerceUK";
    ChannelFromEvent["ROI"] = "eCommerceROI";
    ChannelFromEvent["OUTLET_UK"] = "eCommerceOutletUK";
    ChannelFromEvent["US"] = "eCommerceUS";
    ChannelFromEvent["CA"] = "eCommerceCA";
    ChannelFromEvent["DE"] = "eCommerceDE";
    ChannelFromEvent["FR"] = "eCommerceFR";
    ChannelFromEvent["IT"] = "eCommerceIT";
    ChannelFromEvent["ES"] = "eCommerceES";
    ChannelFromEvent["NL"] = "eCommerceNL";
    ChannelFromEvent["ROE"] = "eCommerceEU";
})(ChannelFromEvent || (exports.ChannelFromEvent = ChannelFromEvent = {}));
exports.csaChannelSuffix = '-CSA';
const mapChannelFromEvent = (channel) => {
    const channelName = channel.replace(exports.csaChannelSuffix, '');
    (0, assert_1.strict)(Object.values(ChannelFromEvent).includes(channelName), `channel: ${channelName} must be one of from ChannelFromEvent`);
    return channelName;
};
exports.mapChannelFromEvent = mapChannelFromEvent;
exports.channelToLocale = {
    [ChannelFromEvent.UK]: [Locales.EN_GB],
    [ChannelFromEvent.ROI]: [Locales.EN_IE],
    [ChannelFromEvent.OUTLET_UK]: [Locales.EN_GB_OUTLET],
    [ChannelFromEvent.US]: [Locales.EN_US],
    [ChannelFromEvent.CA]: [Locales.EN_CA, Locales.FR_CA],
    [ChannelFromEvent.DE]: [Locales.DE_DE],
    [ChannelFromEvent.FR]: [Locales.FR_FR],
    [ChannelFromEvent.IT]: [Locales.IT_IT],
    [ChannelFromEvent.ES]: [Locales.ES_ES],
    [ChannelFromEvent.NL]: [Locales.NL_NL],
    [ChannelFromEvent.ROE]: [
        Locales.EN_EUROPE,
        Locales.DE_AT,
        Locales.NL_BE,
        Locales.FR_BE,
        Locales.DE_CH,
        Locales.FR_CH,
        Locales.IT_CH,
        Locales.FR_LU,
        Locales.EN_LU,
        Locales.IT_SM,
        Locales.EN_SM,
        Locales.EN_DK,
        Locales.EN_PL,
        Locales.EN_SCAND,
    ],
};
// source(Akeneo):[destination1(ct),destination2(ct)]
exports.localeMappingStar2 = {
    en: [types_1.Locale.EN],
    [types_1.Locale.EN_EU]: [types_1.Locale.EN_SM, types_1.Locale.EN_PL, types_1.Locale.EN_DK, types_1.Locale.EN_LU, types_1.Locale.EN_EUROPE, types_1.Locale.EN_SCAND],
    [types_1.Locale.EN_GB]: [types_1.Locale.EN_GB],
    [types_1.Locale.FR_FR]: [types_1.Locale.FR_FR, types_1.Locale.FR_CH, types_1.Locale.FR_BE, types_1.Locale.FR_LU],
    [types_1.Locale.IT_IT]: [types_1.Locale.IT_IT, types_1.Locale.IT_CH, types_1.Locale.IT_SM],
    [types_1.Locale.DE_DE]: [types_1.Locale.DE_DE, types_1.Locale.DE_AT, types_1.Locale.DE_CH],
    [types_1.Locale.NL_NL]: [types_1.Locale.NL_NL, types_1.Locale.NL_BE],
    [types_1.Locale.ES_ES]: [types_1.Locale.ES_ES],
    [types_1.Locale.EN_GB_OUTLET]: [types_1.Locale.EN_GB_OUTLET],
    [types_1.Locale.EN_US]: [types_1.Locale.EN_US],
    [types_1.Locale.EN_IE]: [types_1.Locale.EN_IE],
    [types_1.Locale.EN_CA]: [types_1.Locale.EN_CA],
    [types_1.Locale.FR_CA]: [types_1.Locale.FR_CA],
    [types_1.Locale.EN_FR]: [],
    [types_1.Locale.EN_DE]: [],
    [types_1.Locale.EN_IT]: [],
    [types_1.Locale.EN_ES]: [],
    [types_1.Locale.EN_NL]: [],
    [types_1.Locale.EN_AT]: [],
    [types_1.Locale.DE_AT]: [],
    [types_1.Locale.EN_BE]: [],
    [types_1.Locale.NL_BE]: [],
    [types_1.Locale.FR_BE]: [],
    [types_1.Locale.EN_CH]: [],
    [types_1.Locale.DE_CH]: [],
    [types_1.Locale.FR_CH]: [],
    [types_1.Locale.IT_CH]: [],
    [types_1.Locale.EN_DK]: [],
    [types_1.Locale.EN_PL]: [],
    [types_1.Locale.EN_SM]: [],
    [types_1.Locale.IT_SM]: [],
    [types_1.Locale.EN_LU]: [],
    [types_1.Locale.FR_LU]: [],
    [types_1.Locale.EN_EUROPE]: [],
    [types_1.Locale.EN_SCAND]: [],
};
exports.eventChannelToStore = {
    [ChannelFromEvent.UK]: 'uk',
    [ChannelFromEvent.ROI]: 'roi',
    [ChannelFromEvent.CA]: 'ca',
    [ChannelFromEvent.US]: 'us',
    [ChannelFromEvent.OUTLET_UK]: 'outlet-uk',
    [ChannelFromEvent.DE]: 'de',
    [ChannelFromEvent.FR]: 'fr',
    [ChannelFromEvent.IT]: 'it',
    [ChannelFromEvent.ES]: 'es',
    [ChannelFromEvent.NL]: 'nl',
    [ChannelFromEvent.ROE]: 'roe',
};
exports.eventChannelToCTChannel = {
    [ChannelFromEvent.UK]: 'fullPrice',
    [ChannelFromEvent.ROI]: 'fullPrice',
    [ChannelFromEvent.CA]: 'fullPrice',
    [ChannelFromEvent.US]: 'fullPrice',
    [ChannelFromEvent.OUTLET_UK]: 'outlet',
    [ChannelFromEvent.DE]: 'fullPrice',
    [ChannelFromEvent.FR]: 'fullPrice',
    [ChannelFromEvent.IT]: 'fullPrice',
    [ChannelFromEvent.ES]: 'fullPrice',
    [ChannelFromEvent.NL]: 'fullPrice',
    [ChannelFromEvent.ROE]: 'fullPrice',
};
exports.storeToLocales = new Map([
    ['uk', [Locales.EN_GB]],
    ['ca', [Locales.EN_CA, Locales.FR_CA]],
    ['roi', [Locales.EN_IE]],
    ['outlet-uk', [Locales.EN_GB_OUTLET]],
    ['us', [Locales.EN_US]],
    ['de', [Locales.DE_DE]],
    ['fr', [Locales.FR_FR]],
    ['it', [Locales.IT_IT]],
    ['es', [Locales.ES_ES]],
    ['nl', [Locales.NL_NL]],
    ['roe-ch', [Locales.DE_CH, Locales.FR_CH, Locales.IT_CH]],
    ['roe-pl', [Locales.EN_PL]],
    ['roe-dk', [Locales.EN_DK]],
    ['roe-be', [Locales.FR_BE, Locales.NL_BE]],
    ['roe-at', [Locales.DE_AT]],
    ['roe-lu', [Locales.EN_LU, Locales.FR_LU]],
    ['roe-sm', [Locales.EN_SM, Locales.IT_SM]],
    ['roe', [Locales.EN_EUROPE]],
    ['roe-scand', [Locales.EN_SCAND]],
]);
function getIndexedStoresList() {
    return Array.from(exports.storeToLocales.keys());
}
exports.getIndexedStoresList = getIndexedStoresList;
exports.localesConfluent = [
    'en_GB',
    'en_CA',
    'fr_CA',
    'en_IE',
    'en_GB_OUTLET',
    'en_US',
    'fr_FR',
    'en_FR',
    'de_DE',
    'en_DE',
    'it_IT',
    'en_IT',
    'es_ES',
    'en_ES',
    'nl_NL',
    'en_NL',
    'en_AT',
    'de_AT',
    'en_BE',
    'nl_BE',
    'fr_BE',
    'en_CH',
    'de_CH',
    'fr_CH',
    'it_CH',
    'en_DK',
    'en_PL',
    'en_SM',
    'it_SM',
    'en_LU',
    'fr_LU',
    'en_EUROPE',
    'en_SCAND',
];
exports.defaultLocale = 'en';
exports.currencyMapper = {
    en: '',
    'en-gb': 'GBP',
    'en-ie': 'EUR',
    'en-us': 'USD',
    'en-ca': 'CAD',
    'fr-ca': 'CAD',
    'en-vg': 'GBP',
    'en-gb-outlet': 'GBP',
    'de-de': 'EUR',
    'en-de': 'EUR',
    'fr-fr': 'EUR',
    'en-fr': 'EUR',
    'it-it': 'EUR',
    'en-it': 'EUR',
    'es-es': 'EUR',
    'en-es': 'EUR',
    'nl-nl': 'EUR',
    'en-nl': 'EUR',
    'de-at': 'EUR',
    'en-at': 'EUR',
    'de-ch': 'CHF',
    'fr-ch': 'CHF',
    'it-ch': 'CHF',
    'en-ch': 'CHF',
    'it-sm': 'EUR',
    'en-sm': 'EUR',
    'en-pl': 'PLN',
    'nl-be': 'EUR',
    'fr-be': 'EUR',
    'en-be': 'EUR',
    'en-dk': 'DKK',
    'fr-lu': 'EUR',
    'en-lu': 'EUR',
    'en-ba': 'EUR',
    'en-bg': 'EUR',
    'en-hr': 'EUR',
    'en-cy': 'EUR',
    'en-cz': 'EUR',
    'en-ee': 'EUR',
    'en-fi': 'EUR',
    'en-ge': 'EUR',
    'en-gi': 'EUR',
    'en-gr': 'EUR',
    'en-hu': 'EUR',
    'en-is': 'EUR',
    'en-lv': 'EUR',
    'en-li': 'EUR',
    'en-lt': 'EUR',
    'en-mt': 'EUR',
    'en-mc': 'EUR',
    'en-me': 'EUR',
    'en-mk': 'EUR',
    'en-no': 'EUR',
    'en-pt': 'EUR',
    'en-md': 'EUR',
    'en-ro': 'EUR',
    'en-rs': 'EUR',
    'en-sk': 'EUR',
    'en-si': 'EUR',
    'en-se': 'EUR',
    'en-tr': 'EUR',
    'en-europe': 'EUR',
    'en-scand': 'EUR',
};
/**
 * Needed for zones in the shipping methods
 */
//  STAR2-TODO - WE NEED TO REFACTOR THIS BECAUSE NOW THERE ARE MANY COUNTRIES WITH SAME CURRENCY
exports.currencyCountryMapper = {
    GBP: 'UK',
    EUR: 'IE',
    USD: 'US',
    CAD: 'CA',
};
function countryToCurrencyMapper(country) {
    const [currency] = Object.entries(exports.currencyCountryMapper).find(([_, value]) => value === country.toUpperCase()) ?? [];
    return currency;
}
exports.countryToCurrencyMapper = countryToCurrencyMapper;
const countryCurrencyMapper = {
    UK: 'GBP',
    IE: 'EUR',
    US: 'USD',
    PR: 'USD',
    CA: 'CAD',
    DE: 'EUR',
    IT: 'EUR',
    FR: 'EUR',
    NL: 'EUR',
    ES: 'EUR',
    //  STAR2 ENTRIES
    AT: 'EUR',
    BE: 'EUR',
    LU: 'EUR',
    SM: 'EUR',
    DK: 'DKK',
    PL: 'PLN',
    CH: 'CHF',
};
function mapCountryToCurrency(country) {
    return countryCurrencyMapper[country?.toUpperCase()];
}
exports.mapCountryToCurrency = mapCountryToCurrency;
const storeKeyMap = {
    en: '',
    'en-gb': 'uk',
    'en-ie': 'roi',
    'en-us': 'us',
    'en-ca': 'ca',
    'fr-ca': 'ca',
    'en-vg': 'outlet-uk',
    'en-gb-outlet': 'outlet-uk',
    'de-de': 'de',
    'en-de': 'de',
    'fr-fr': 'fr',
    'en-fr': 'fr',
    'it-it': 'it',
    'en-it': 'it',
    'es-es': 'es',
    'en-es': 'es',
    'nl-nl': 'nl',
    'en-nl': 'nl',
    'de-at': 'roe-at',
    'en-at': 'roe-at',
    'de-ch': 'roe-ch',
    'fr-ch': 'roe-ch',
    'it-ch': 'roe-ch',
    'en-ch': 'roe-ch',
    'it-sm': 'roe-sm',
    'en-sm': 'roe-sm',
    'en-pl': 'roe-pl',
    'nl-be': 'roe-be',
    'fr-be': 'roe-be',
    'en-be': 'roe-be',
    'en-dk': 'roe-dk',
    'fr-lu': 'roe-lu',
    'en-lu': 'roe-lu',
    'en-ba': 'roe',
    'en-bg': 'roe',
    'en-hr': 'roe',
    'en-cy': 'roe',
    'en-cz': 'roe',
    'en-ee': 'roe',
    'en-fi': 'roe-scand',
    'en-ge': 'roe',
    'en-gi': 'roe',
    'en-gr': 'roe',
    'en-hu': 'roe',
    'en-is': 'roe',
    'en-lv': 'roe',
    'en-li': 'roe',
    'en-lt': 'roe',
    'en-mt': 'roe',
    'en-mc': 'roe',
    'en-me': 'roe',
    'en-mk': 'roe',
    'en-no': 'roe-scand',
    'en-pt': 'roe',
    'en-md': 'roe',
    'en-ro': 'roe',
    'en-rs': 'roe',
    'en-sk': 'roe',
    'en-si': 'roe',
    'en-se': 'roe-scand',
    'en-tr': 'roe',
    'en-europe': 'roe',
    'en-scand': 'roe-scand',
};
const ctLocaleToStoreLocales = (locale) => {
    // The locales are commented to be switched off according to ticket CICD-9291.
    const multiStoreLocalesMap = {
        'en-scand': [
            'en-fi',
            // 'en-no',
            'en-se',
        ],
        'en-europe': [
            // 'en-ba',
            'en-bg',
            'en-hr',
            'en-cy',
            'en-cz',
            // 'en-ee',
            // 'en-ge',
            // 'en-gi',
            'en-gr',
            'en-hu',
            // 'en-is',
            'en-lv',
            // 'en-li',
            // 'en-lt',
            'en-mt',
            // 'en-mc',
            // 'en-me',
            // 'en-mk',
            'en-pt',
            // 'en-md',
            'en-ro',
            // 'en-rs',
            // 'en-sk',
            // 'en-si',
            // 'en-tr',
        ],
    };
    return multiStoreLocalesMap[locale.toLowerCase()] ?? [locale];
};
exports.ctLocaleToStoreLocales = ctLocaleToStoreLocales;
const getStar2Countries = () => {
    const countryCodesSet = Array.from(i18n_1.supportedLocales).reduce((acc, locale) => {
        const storeKey = storeKeyMapper(locale);
        if (!isStar2StoreKey(storeKey)) {
            return acc;
        }
        const country = new Intl.Locale(locale).region;
        if (country) {
            acc.add(country.toUpperCase());
        }
        return acc;
    }, new Set());
    return Array.from(countryCodesSet).map((countryCode) => ({
        countryCode,
        currencyCode: mapCountryToCurrency(countryCode) || 'EUR',
    }));
};
exports.getStar2Countries = getStar2Countries;
const isStar2Country = (countryCode) => {
    const countryCodeUpperCase = countryCode.toUpperCase();
    return (0, exports.getStar2Countries)().some((country) => country.countryCode === countryCodeUpperCase);
};
exports.isStar2Country = isStar2Country;
const ctLocaleToISO = {
    en: '',
    'en-gb': 'en-gb',
    'en-ie': 'en-ie',
    'en-us': 'en-us',
    'en-ca': 'en-ca',
    'fr-ca': 'fr-ca',
    'en-vg': 'en-gb',
    'en-gb-outlet': 'en-gb',
};
const registeredFromCountries = new Set(['us', 'ca', 'fr', 'de', 'pl', 'se', 'ch', 'es', 'pt', 'at']);
const localeToRegisteredFromMap = {
    'en-gb': 'uk',
    'en-gb-outlet': 'outletuk',
    'en-vg': 'outletuk',
    'en-ie': 'roi',
};
function getCtLocleToISO(locale) {
    const lowerLocale = locale.toLowerCase();
    return ctLocaleToISO[lowerLocale];
}
exports.getCtLocleToISO = getCtLocleToISO;
function storeKeyMapper(locale) {
    const lowerLocale = locale?.toLowerCase();
    return storeKeyMap[lowerLocale];
}
exports.storeKeyMapper = storeKeyMapper;
function localeToRegisteredFromMapper(locale) {
    const lowerLocale = locale.toLowerCase();
    let registeredFrom = localeToRegisteredFromMap[lowerLocale];
    if (!registeredFrom) {
        const countryCode = locale.split('-')[1];
        if (registeredFromCountries.has(countryCode)) {
            registeredFrom = countryCode;
        }
    }
    return registeredFrom || 'Unknown';
}
exports.localeToRegisteredFromMapper = localeToRegisteredFromMapper;
function isStar2StoreKey(key) {
    return Object.values(types_1.Star2Store).includes(key);
}
exports.isStar2StoreKey = isStar2StoreKey;
const isStar2StoreLocale = (locale) => {
    return isStar2StoreKey(storeKeyMapper(locale));
};
exports.isStar2StoreLocale = isStar2StoreLocale;
const storeToChannelsMap = {
    uk: ChannelFromEvent.UK,
    ca: ChannelFromEvent.CA,
    us: ChannelFromEvent.US,
    roi: ChannelFromEvent.ROI,
    'outlet-uk': ChannelFromEvent.OUTLET_UK,
    fr: ChannelFromEvent.FR,
    de: ChannelFromEvent.DE,
    it: ChannelFromEvent.IT,
    es: ChannelFromEvent.ES,
    nl: ChannelFromEvent.NL,
    'roe-at': ChannelFromEvent.ROE,
    'roe-be': ChannelFromEvent.ROE,
    'roe-ch': ChannelFromEvent.ROE,
    'roe-lu': ChannelFromEvent.ROE,
    'roe-sm': ChannelFromEvent.ROE,
    'roe-dk': ChannelFromEvent.ROE,
    'roe-pl': ChannelFromEvent.ROE,
    'roe-scand': ChannelFromEvent.ROE,
    roe: ChannelFromEvent.ROE,
};
const storeToFitMap = {
    uk: 'ukFit',
    ca: 'usFit',
    us: 'usFit',
    roi: 'ukFit',
    'outlet-uk': 'ukFit',
    fr: 'euFit',
    de: 'euFit',
    it: 'euFit',
    es: 'euFit',
    nl: 'euFit',
    'roe-at': 'euFit',
    'roe-be': 'euFit',
    'roe-ch': 'euFit',
    'roe-lu': 'euFit',
    'roe-sm': 'euFit',
    'roe-dk': 'euFit',
    'roe-pl': 'euFit',
    'roe-scand': 'euFit',
    roe: 'euFit',
};
const storeToFitLabelMap = {
    uk: 'ukFitLabel',
    ca: 'usFitLabel',
    us: 'usFitLabel',
    roi: 'ukFitLabel',
    'outlet-uk': 'ukFitLabel',
    fr: 'euFitLabel',
    de: 'euFitLabel',
    it: 'euFitLabel',
    es: 'euFitLabel',
    nl: 'euFitLabel',
    'roe-at': 'euFitLabel',
    'roe-be': 'euFitLabel',
    'roe-ch': 'euFitLabel',
    'roe-lu': 'euFitLabel',
    'roe-sm': 'euFitLabel',
    'roe-dk': 'euFitLabel',
    'roe-pl': 'euFitLabel',
    'roe-scand': 'euFitLabel',
    roe: 'euFitLabel',
};
const storeToSizeMap = {
    uk: 'ukSize',
    ca: 'usSize',
    us: 'usSize',
    roi: 'ukSize',
    'outlet-uk': 'ukSize',
    fr: 'euSize',
    de: 'euSize',
    it: 'euSize',
    es: 'euSize',
    nl: 'euSize',
    'roe-at': 'euSize',
    'roe-be': 'euSize',
    'roe-ch': 'euSize',
    'roe-lu': 'euSize',
    'roe-sm': 'euSize',
    'roe-dk': 'euSize',
    'roe-pl': 'euSize',
    'roe-scand': 'euSize',
    roe: 'euSize',
};
function getFitAttributeName(store) {
    return storeToFitMap[store];
}
exports.getFitAttributeName = getFitAttributeName;
function getFitLabelAttributeName(store) {
    return storeToFitLabelMap[store];
}
exports.getFitLabelAttributeName = getFitLabelAttributeName;
function getSizeAttributeName(store) {
    return storeToSizeMap[store];
}
exports.getSizeAttributeName = getSizeAttributeName;
function fitMapper(locale) {
    return getFitAttributeName(storeKeyMapper(locale));
}
exports.fitMapper = fitMapper;
function fitLabelMapper(locale) {
    return getFitLabelAttributeName(storeKeyMapper(locale));
}
exports.fitLabelMapper = fitLabelMapper;
function sizeMapper(locale) {
    return getSizeAttributeName(storeKeyMapper(locale));
}
exports.sizeMapper = sizeMapper;
function storeToChannelsMapper(store) {
    return storeToChannelsMap[store];
}
exports.storeToChannelsMapper = storeToChannelsMapper;
function getAgeGroup(globalSize) {
    const globalSizeNumber = parseInt(globalSize, 10);
    if (globalSizeNumber >= 8020 && globalSizeNumber <= 9170) {
        return AgeGroup.ADULT;
    }
    if (globalSizeNumber >= 20 && globalSizeNumber <= 135) {
        return AgeGroup.INFANT;
    }
    if (globalSizeNumber >= 6010 && globalSizeNumber <= 6105) {
        return AgeGroup.JUNIOR;
    }
    return null;
}
exports.getAgeGroup = getAgeGroup;
const localeToCountryCode = {
    en: '',
    'en-gb': 'GB',
    'en-ie': 'IE',
    'en-us': 'US',
    'en-ca': 'CA',
    'fr-ca': 'CA',
    'en-vg': 'GB',
    'en-gb-outlet': 'GB',
    'fr-fr': 'FR',
    'en-fr': 'FR',
    'de-de': 'DE',
    'en-de': 'DE',
    'it-it': 'IT',
    'en-it': 'IT',
    'es-es': 'ES',
    'en-es': 'ES',
    'nl-nl': 'NL',
    'en-nl': 'NL',
    'de-at': 'AT',
    'en-at': 'AT',
    'nl-be': 'BE',
    'fr-be': 'BE',
    'en-be': 'BE',
    'de-ch': 'CH',
    'fr-ch': 'CH',
    'it-ch': 'CH',
    'en-ch': 'CH',
    'fr-lu': 'LU',
    'en-lu': 'LU',
    'it-sm': 'SM',
    'en-sm': 'SM',
    'en-dk': 'DK',
    'en-pl': 'PL',
    'en-europe': 'GB',
    'en-scand': 'GB',
};
const COUNTRY_CODES = [
    'GB',
    'IE',
    'US',
    'CA',
    'FR',
    'DE',
    'IT',
    'ES',
    'NL',
    'AT',
    'BE',
    'CH',
    'LU',
    'SM',
    'DK',
    'PL',
];
const STAR2_COUNTRY_TO_STORE_KEY_MAPPING = {
    bg: 'roe',
    hr: 'roe',
    cy: 'roe',
    cz: 'roe',
    gr: 'roe',
    hu: 'roe',
    lv: 'roe',
    mt: 'roe',
    ro: 'roe',
    pt: 'roe',
    at: 'roe-at',
    be: 'roe-be',
    ch: 'roe-ch',
    de: 'de',
    dk: 'roe-dk',
    es: 'es',
    fi: 'roe-scand',
    fr: 'fr',
    it: 'it',
    lu: 'roe-lu',
    nl: 'nl',
    pl: 'roe-pl',
    se: 'roe-scand',
};
const validIsoCodes = new Set(COUNTRY_CODES);
/**
 * Maps country code from STAR2 into a CT StoreKey
 * @param countryCode to-letter iso code like 'IT', 'SE', ... the case doesn't matter
 * @returns CT store key for given country (like 'be' => 'roe-be') or undefined if there is no mapping.
 */
function mapCountryCodeToStar2StoreKey(countryCode) {
    return STAR2_COUNTRY_TO_STORE_KEY_MAPPING[countryCode.toLowerCase()];
}
exports.mapCountryCodeToStar2StoreKey = mapCountryCodeToStar2StoreKey;
const CtLocaleMappings = {
    DEFAULT_LOCALE: 'en',
    STOREFRONT_OUTLET_LOCALE: 'en-vg',
    CT_OUTLET_LOCALE: 'en-GB-OUTLET',
    EN_SCAND: 'en-SCAND',
};
exports.STAR1Locales = [
    types_1.Locale.EN_GB,
    types_1.Locale.EN_IE,
    types_1.Locale.EN_US,
    types_1.Locale.EN_CA,
    types_1.Locale.FR_CA,
    'en-vg',
    'en-GB-OUTLET',
];
exports.LocaleStar2 = {
    EN_FR: 'en-fr',
    FR_FR: 'fr-fr',
    EN_DE: 'en-de',
    DE_DE: 'de-de',
    EN_ES: 'en-es',
    ES_ES: 'es-es',
    EN_IT: 'en-it',
    IT_IT: 'it-it',
    EN_NL: 'en-nl',
    NL_NL: 'nl-nl',
    EN_AT: 'en-at',
    DE_AT: 'de-at',
    EN_BE: 'en-be',
    EN_BG: 'en-bg',
    NL_BE: 'nl-be',
    FR_BE: 'fr-be',
    EN_CH: 'en-ch',
    EN_CY: 'en-cy',
    EN_CZ: 'en-cz',
    DE_CH: 'de-ch',
    FR_CH: 'fr-ch',
    IT_CH: 'it-ch',
    EN_DK: 'en-dk',
    EN_PL: 'en-pl',
    EN_LU: 'en-lu',
    FR_LU: 'fr-lu',
    EN_FI: 'en-fi',
    EN_GR: 'en-gr',
    EN_HU: 'en-hu',
    EN_LI: 'en-li',
    EN_LV: 'en-lv',
    EN_MT: 'en-mt',
    EN_PT: 'en-pt',
    EN_RO: 'en-ro',
    EN_HR: 'en-hr',
    EN_SE: 'en-se',
    EN_SCAND: 'en-SCAND',
    EN_EUROPE: 'en-EUROPE',
    ROE: 'roe',
};
exports.STAR2LocalesWithMultipleLanguages = [
    exports.LocaleStar2.EN_FR,
    exports.LocaleStar2.FR_FR,
    exports.LocaleStar2.EN_DE,
    exports.LocaleStar2.DE_DE,
    exports.LocaleStar2.EN_ES,
    exports.LocaleStar2.ES_ES,
    exports.LocaleStar2.EN_IT,
    exports.LocaleStar2.IT_IT,
    exports.LocaleStar2.EN_NL,
    exports.LocaleStar2.NL_NL,
    exports.LocaleStar2.EN_AT,
    exports.LocaleStar2.DE_AT,
    exports.LocaleStar2.EN_BE,
    exports.LocaleStar2.NL_BE,
    exports.LocaleStar2.FR_BE,
    exports.LocaleStar2.EN_CH,
    exports.LocaleStar2.DE_CH,
    exports.LocaleStar2.FR_CH,
    exports.LocaleStar2.IT_CH,
    exports.LocaleStar2.EN_DK,
    exports.LocaleStar2.EN_PL,
    exports.LocaleStar2.EN_LU,
    exports.LocaleStar2.FR_LU,
];
exports.STAR2LocalesScand = [exports.LocaleStar2.EN_FI, exports.LocaleStar2.EN_SE];
/**
 * Converts NextJS locale (aka rawlocale, i.e. 'en-mt', 'it-it') into CT locale (i.e. 'en-europe', ...)
 * Acts as getCtLocale function in @storefront.
 */
function convertRawLocaleToCtLocale(rawLocale) {
    if (!rawLocale || rawLocale === CtLocaleMappings.DEFAULT_LOCALE) {
        return CtLocaleMappings.DEFAULT_LOCALE;
    }
    if (isOutletLocale(rawLocale)) {
        return CtLocaleMappings.CT_OUTLET_LOCALE;
    }
    if (rawLocale === exports.LocaleStar2.EN_SCAND ||
        exports.STAR2LocalesScand.some((star2Locale) => star2Locale.toLowerCase() === rawLocale.toLowerCase())) {
        return exports.LocaleStar2.EN_SCAND;
    }
    if (rawLocale === exports.LocaleStar2.EN_EUROPE ||
        ![...exports.STAR1Locales, ...exports.STAR2LocalesWithMultipleLanguages, ...exports.STAR2LocalesScand].some((starLocale) => starLocale.toLowerCase() === rawLocale.toLowerCase())) {
        return exports.LocaleStar2.EN_EUROPE;
    }
    const [lang, country] = rawLocale.split('-');
    return `${lang}-${country.toLocaleUpperCase()}`;
}
exports.convertRawLocaleToCtLocale = convertRawLocaleToCtLocale;
/**
 * Maps locale string to ISO country code
 * @param locale - Locale string (e.g. 'en-GB', 'fr-FR')
 * @returns Valid ISO country code or 'GB' as fallback
 */
function countryCodeMapper(locale) {
    const lowerLocale = locale.toLowerCase();
    const mapped = localeToCountryCode[lowerLocale];
    if (mapped && validIsoCodes.has(mapped)) {
        return mapped;
    }
    const [, country] = lowerLocale.split('-');
    const upperCountry = country?.toUpperCase();
    return validIsoCodes.has(upperCountry) ? upperCountry : 'GB';
}
exports.countryCodeMapper = countryCodeMapper;
const LANGUAGE_CODES = ['en', 'fr', 'de', 'it', 'es', 'nl'];
const validLanguageCodes = new Set(LANGUAGE_CODES);
/**
 * Maps locale string to ISO language code
 * @param locale - Locale string (e.g. 'en-GB', 'fr-FR')
 * @returns Valid ISO language code or 'en' as fallback
 */
function languageCodeMapper(locale) {
    const lowerLocale = locale.toLowerCase();
    const [language] = lowerLocale.split('-');
    return validLanguageCodes.has(language) ? language : 'en';
}
exports.languageCodeMapper = languageCodeMapper;
const isStar1Locale = (locale) => {
    const star1Locales = ['en-gb', 'en-ie', 'en-us', 'en-ca', 'fr-ca', 'en-vg', 'en-gb-outlet', 'en'];
    return !!locale && star1Locales.includes(locale.toLowerCase());
};
exports.isStar1Locale = isStar1Locale;
const localeToChannel = {
    'en-gb': 'fullPrice',
    'en-ie': 'fullPrice',
    'en-us': 'fullPrice',
    'en-ca': 'fullPrice',
    'fr-ca': 'fullPrice',
    'en-vg': 'outlet',
    'en-gb-outlet': 'outlet',
    'fr-fr': 'fullPrice',
    'en-fr': 'fullPrice',
    'de-de': 'fullPrice',
    'en-de': 'fullPrice',
    'it-it': 'fullPrice',
    'en-it': 'fullPrice',
    'es-es': 'fullPrice',
    'en-es': 'fullPrice',
    'nl-nl': 'fullPrice',
    'en-nl': 'fullPrice',
    'de-at': 'fullPrice',
    'en-at': 'fullPrice',
    'nl-be': 'fullPrice',
    'fr-be': 'fullPrice',
    'en-be': 'fullPrice',
    'de-ch': 'fullPrice',
    'fr-ch': 'fullPrice',
    'it-ch': 'fullPrice',
    'en-ch': 'fullPrice',
    'fr-lu': 'fullPrice',
    'en-lu': 'fullPrice',
    'it-sm': 'fullPrice',
    'en-sm': 'fullPrice',
    'en-dk': 'fullPrice',
    'en-pl': 'fullPrice',
    'en-europe': 'fullPrice',
    'en-scand': 'fullPrice',
};
function channelMapper(locale) {
    const lowerLocale = locale.toLowerCase();
    return localeToChannel[lowerLocale];
}
exports.channelMapper = channelMapper;
var StockStatus;
(function (StockStatus) {
    StockStatus["IN_STOCK"] = "inStock";
    StockStatus["OUT_OF_STOCK"] = "outOfStock";
})(StockStatus || (exports.StockStatus = StockStatus = {}));
const localeToDateFnsLocale = {
    'en-gb': locale_1.enGB,
    'en-ie': locale_1.enIE,
    'en-us': locale_1.enUS,
    'en-ca': locale_1.enCA,
    'fr-ca': locale_1.frCA,
    'en-vg': locale_1.enGB,
    'en-gb-outlet': locale_1.enGB,
    'fr-fr': locale_1.fr,
    'en-fr': locale_1.enGB,
    'de-de': locale_1.de,
    'en-de': locale_1.enGB,
    'it-it': locale_1.it,
    'en-it': locale_1.enGB,
    'es-es': locale_1.es,
    'en-es': locale_1.enGB,
    'nl-nl': locale_1.nl,
    'en-nl': locale_1.enGB,
    'de-at': locale_1.deAT,
    'en-at': locale_1.enGB,
    'nl-be': locale_1.nl,
    'fr-be': locale_1.fr,
    'en-be': locale_1.enGB,
    'de-ch': locale_1.de,
    'fr-ch': locale_1.frCH,
    'it-ch': locale_1.itCH,
    'en-ch': locale_1.enGB,
    'fr-lu': locale_1.fr,
    'en-lu': locale_1.enGB,
    'it-sm': locale_1.it,
    'en-sm': locale_1.enGB,
    'en-dk': locale_1.enGB,
    'en-pl': locale_1.enGB,
    'en-europe': locale_1.enGB,
    'en-scand': locale_1.enGB,
};
function localeToDateFnsLocaleMapper(locale) {
    return localeToDateFnsLocale[locale.toLowerCase()];
}
exports.localeToDateFnsLocaleMapper = localeToDateFnsLocaleMapper;
var DeliveryInstructionsKeys;
(function (DeliveryInstructionsKeys) {
    DeliveryInstructionsKeys["RECEPTION"] = "reception";
    DeliveryInstructionsKeys["NEIGHBOUR"] = "neighbour";
    DeliveryInstructionsKeys["SAFE_PLACE"] = "safe-place";
    DeliveryInstructionsKeys["OTHER"] = "other";
})(DeliveryInstructionsKeys || (exports.DeliveryInstructionsKeys = DeliveryInstructionsKeys = {}));
exports.deliveryInstructionsKeys = Object.values(DeliveryInstructionsKeys);
var FulfillmentGroup;
(function (FulfillmentGroup) {
    FulfillmentGroup["UK"] = "uk_ecom";
    FulfillmentGroup["UK_OUTLET"] = "uk_outlet_ecom";
    FulfillmentGroup["US"] = "us_ecom";
    FulfillmentGroup["ROI"] = "uk_ecom";
    FulfillmentGroup["CA"] = "canada_ecom";
})(FulfillmentGroup || (exports.FulfillmentGroup = FulfillmentGroup = {}));
const localeToFulfillmentGroup = {
    'en-gb': FulfillmentGroup.UK,
    'en-ie': FulfillmentGroup.ROI,
    'en-us': FulfillmentGroup.US,
    'en-ca': FulfillmentGroup.CA,
    'fr-ca': FulfillmentGroup.CA,
    'en-vg': FulfillmentGroup.UK_OUTLET,
    'en-gb-outlet': FulfillmentGroup.UK_OUTLET,
};
function fulfillmentGroupMapper(locale) {
    return localeToFulfillmentGroup[locale.toLowerCase()];
}
exports.fulfillmentGroupMapper = fulfillmentGroupMapper;
function getAttributes(product) {
    let attributes;
    if ('masterData' in product) {
        attributes = product.masterData.current.masterVariant.attributes;
    }
    else if ('masterVariant' in product) {
        attributes = product.masterVariant.attributes;
    }
    else if ('variant' in product) {
        attributes = product.variant.attributes;
    }
    else {
        attributes = product.attributes;
    }
    return attributes;
}
function getAttributeValue(attributeName, product) {
    const findFunction = (attr) => attr.name === attributeName;
    const attributeObject = getAttributes(product)?.find(findFunction);
    return attributeObject?.value;
}
exports.getAttributeValue = getAttributeValue;
const getPrimaryCategory = (product, rootCategory, locale) => {
    const primaryCategories = getAttributeValue('primaryCategories', product);
    //  [{name: 'scope'; value: string;}, {name: 'primaryCategory'; value: CategoryReference;}]
    const primaryCategoryEntry = primaryCategories?.find((primaryCategoryArray) => {
        const scope = primaryCategoryArray.find((entry) => entry.name === 'scope');
        const locales = Array.isArray(locale) ? locale : [locale];
        return locales.includes(scope?.value);
    });
    const primaryCategoryReference = primaryCategoryEntry?.find((entry) => entry.name === 'primaryCategory')
        ?.value;
    const findRootCategory = primaryCategoryReference?.obj?.ancestors[0]?.id === rootCategory.id;
    return (findRootCategory && primaryCategoryReference?.obj) || undefined;
};
exports.getPrimaryCategory = getPrimaryCategory;
function isDigitalProduct(product, skipExpandedProductCheck) {
    if (skipExpandedProductCheck !== true) {
        (0, assert_1.strict)(product.productType.obj, 'Product type is not expanded');
    }
    return types_1.ProductTypesEnum.EGIFT_CARD === product.productType?.obj?.key;
}
exports.isDigitalProduct = isDigitalProduct;
function isPhysicalGiftCardProduct(product) {
    (0, assert_1.strict)(product.productType.obj, 'Product type is not expanded');
    return types_1.ProductTypesEnum.GIFT_CARD === product.productType.obj.key;
}
exports.isPhysicalGiftCardProduct = isPhysicalGiftCardProduct;
function isGiftCardProduct(product) {
    (0, assert_1.strict)(product.productType.obj, 'Product type is not expanded');
    return [types_1.ProductTypesEnum.EGIFT_CARD, types_1.ProductTypesEnum.GIFT_CARD].includes(product.productType.obj.key);
}
exports.isGiftCardProduct = isGiftCardProduct;
function isDigitalCart(cart, skipExpandedProductCheck) {
    return (cart?.lineItems?.length > 0 &&
        cart?.lineItems?.every((lineItem) => isDigitalProduct(lineItem, skipExpandedProductCheck)));
}
exports.isDigitalCart = isDigitalCart;
function isGiftCardCart(cart) {
    return cart?.lineItems?.length > 0 && cart?.lineItems?.every((lineItem) => isGiftCardProduct(lineItem));
}
exports.isGiftCardCart = isGiftCardCart;
function cartHasPhysicalGiftCard(cart) {
    return cart?.lineItems?.length > 0 && cart?.lineItems?.some((lineItem) => isPhysicalGiftCardProduct(lineItem));
}
exports.cartHasPhysicalGiftCard = cartHasPhysicalGiftCard;
function cartHasGiftCard(cart) {
    return cart.lineItems.some((lineItem) => isGiftCardProduct(lineItem));
}
exports.cartHasGiftCard = cartHasGiftCard;
exports.DUMMY_ADDRESS_PREFIX = 'DUMMY-';
const getDummyAddress = (cart) => {
    const key = `${exports.DUMMY_ADDRESS_PREFIX}${cart.store?.key}-${new Date().getTime()}`;
    switch (cart.store?.key) {
        case 'uk':
            return {
                key,
                country: 'GB',
                postalCode: 'BA16 0EQ',
                firstName: 'Clarks',
                lastName: 'Clarks',
                phone: '012345678',
                city: 'Somerset',
                company: 'Clarks',
                streetName: 'High Street',
                streetNumber: '40',
            };
        case 'outlet-uk':
            return {
                key,
                country: 'GB',
                postalCode: 'BA16 0EQ',
                firstName: 'Clarks',
                lastName: 'Clarks',
                phone: '012345678',
                city: 'Somerset',
                company: 'Clarks',
                streetName: 'High Street',
                streetNumber: '40',
            };
        case 'roi':
            return {
                key,
                country: 'IE',
                postalCode: 'DN06069',
                firstName: 'Clarks',
                lastName: 'Clarks',
                phone: '012345678',
                city: 'Dublin',
                company: 'Clarks',
                streetName: 'Henry Street',
                streetNumber: '25',
            };
        case 'ca':
            return {
                key,
                country: 'CA',
                postalCode: 'L5L 5X5',
                firstName: 'Clarks',
                lastName: 'Clarks',
                phone: '012345678',
                city: 'Mississauga',
                company: 'Clarks',
                state: 'ON',
                streetName: 'Ridgeway Drive, Unit #1',
                streetNumber: '4090',
            };
        case 'us':
            return {
                key,
                country: 'US',
                postalCode: '02494',
                firstName: 'Clarks',
                lastName: 'Clarks',
                phone: '012345678',
                city: 'Needham',
                company: 'Clarks',
                streetName: 'Kendrick Street',
                streetNumber: '140',
                state: 'MA',
            };
        default:
            throw new Error(`Unsupported store: ${cart.store?.key}`);
    }
};
exports.getDummyAddress = getDummyAddress;
const hasDummyAddress = (cart) => (cart.shippingAddress?.key ?? '').startsWith('DUMMY-');
exports.hasDummyAddress = hasDummyAddress;
const hasValidDummyAddress = (cart) => (cart.shippingAddress?.key ?? '').startsWith(`DUMMY-${cart.store?.key}`);
exports.hasValidDummyAddress = hasValidDummyAddress;
/**
 * Override shipping address for digital carts.
 * If no shipping and no billing address, we default to the clarks HQ address.
 * If we do have a billing address and it doesn't match existing shipping address, then we use billing as shipping address.
 */
const getShippingAddressOverride = (cart, cartActions) => {
    if (!isDigitalCart(cart)) {
        return null;
    }
    const shippingMethodAction = cartActions.find((cartAction) => cartAction.action === 'setShippingAddress');
    if (shippingMethodAction) {
        return null;
    }
    const billingAddressAction = cartActions.find((cartAction) => cartAction.action === 'setBillingAddress');
    const billingAddress = billingAddressAction?.address || cart.billingAddress;
    const isUpdatedBillingAddress = !!billingAddress && cart.shippingAddress?.key !== billingAddress?.key;
    const shouldUpdateShippingAddress = !cart.shippingAddress || isUpdatedBillingAddress;
    if (!shouldUpdateShippingAddress) {
        return null;
    }
    return billingAddress || (0, exports.getDummyAddress)(cart);
};
const hasProductTypeExpanded = (cart) => !!(cart.lineItems.length > 0 && cart.lineItems[0].productType.obj);
const getDigitalCartUpdateActions = (cart, initialActions = []) => {
    if (cart.lineItems.length === 0) {
        return (0, exports.hasDummyAddress)(cart)
            ? [
                {
                    action: 'setShippingAddress',
                },
            ]
            : [];
    }
    if (hasProductTypeExpanded(cart)) {
        if ((0, exports.hasDummyAddress)(cart) && !isDigitalCart(cart)) {
            return [
                {
                    action: 'setShippingAddress',
                },
            ];
        }
        const shippingAddress = getShippingAddressOverride(cart, initialActions);
        if (shippingAddress) {
            return [
                {
                    action: 'setShippingAddress',
                    address: shippingAddress,
                },
            ];
        }
    }
    return [];
};
exports.getDigitalCartUpdateActions = getDigitalCartUpdateActions;
exports.INVENTORY_RESERVATION_STORES = ['outlet-uk'];
const isStoreWithStockReservation = (storeKey) => storeKey ? exports.INVENTORY_RESERVATION_STORES.includes(storeKey) : false;
exports.isStoreWithStockReservation = isStoreWithStockReservation;
// https://pangaea.atlassian.net/browse/REP-11799
function upperCasePromoCode(code) {
    if (code.length <= 15) {
        return code.toUpperCase();
    }
    return code;
}
exports.upperCasePromoCode = upperCasePromoCode;
function isOutlet(cart) {
    return isOutletLocale(cart.locale);
}
exports.isOutlet = isOutlet;
function isOutletLocale(locale) {
    return locale?.toLocaleLowerCase() === 'en-gb-outlet' || locale?.toLocaleLowerCase() === 'en-vg';
}
exports.isOutletLocale = isOutletLocale;
function generateInvalidateDelivery(cart) {
    const actions = [];
    if (cart.shippingInfo?.shippingMethod) {
        actions.push({
            action: 'setShippingMethod',
        });
    }
    if (cart.custom?.fields?.deliveryInfo) {
        actions.push({
            action: 'setCustomField',
            name: 'deliveryInfo',
        });
    }
    if (cart.custom?.fields?.shippingType) {
        actions.push({
            action: 'setCustomField',
            name: 'shippingType',
        });
    }
    return actions;
}
exports.generateInvalidateDelivery = generateInvalidateDelivery;
function parseToCents(amount) {
    if (typeof amount !== 'number') {
        throw new Error('Amount must be type of number to parse it to cents format.');
    }
    return Math.round(amount * 100);
}
exports.parseToCents = parseToCents;
const getLocalizedBooleanValue = (value, locale) => {
    if (!value) {
        return false;
    }
    const stringValue = value[locale] ?? value[exports.defaultLocale];
    if (stringValue === undefined) {
        return false;
    }
    return stringValue.toUpperCase() === types_1.LocalizedBooleanValues.YES;
};
exports.getLocalizedBooleanValue = getLocalizedBooleanValue;
const getLocalizedBooleanAttributeValue = (attributes, name, locale) => {
    const value = attributes?.find((attr) => attr.name === name)?.value;
    return (0, exports.getLocalizedBooleanValue)(value, locale);
};
exports.getLocalizedBooleanAttributeValue = getLocalizedBooleanAttributeValue;
const normalizeLocaleCase = (locale) => {
    return locale.toLowerCase().replace(/-([a-z]+)/g, (_, p1) => `-${p1.toUpperCase()}`);
};
exports.normalizeLocaleCase = normalizeLocaleCase;
const isSupportedCtLocale = (ctLocale) => {
    return Object.values(Locales).some((locale) => ctLocale.toLowerCase() === locale.toLowerCase());
};
exports.isSupportedCtLocale = isSupportedCtLocale;
//# sourceMappingURL=index.js.map